var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.$gettext('Soft mobility outing')}},[_c('fa-icon',{attrs:{"icon":"bus"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }